import { RouteConfig } from "vue-router";
import ROUTES from "../routes";

export const ShareRoutes: Array<RouteConfig> = [
  {
    path: "/share/:siteId?",
    alias: ["/share"],
    name: ROUTES.SHARE,
    component: () =>
      import(
        /* webpackChunkName: 'share' */
        /* webpackPrefetch: true */
        "../../view/wrappers/share.vue"
      ),
  },
];
